module.exports = __webpack_public_path__ + "img/rb-leipzig.f4b3f532.png";